import React from "react";
import RestRequest from "../../tools/RestRequest";
import config from "../../config";
import Price from "../../tools/Price";
import Currency from "../../tools/Currency";
import {Modal} from 'react-bootstrap';
import BuyOneClick from "../BuyOneClick/BuyOneClick";

require('ion-rangeslider');

export default class SetWeight extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            product: {},
            show: false,
            weight: 0,
        }
    }

    componentDidMount() {
        this.loadProduct();
    }

    loadProduct() {
        RestRequest.one(config.restCatalog, this.props.product_id, '?expand=imageUrl,weight').then(data => {
            this.setState({product: data});
        });
    }

    handleClose() {
        this.setShow(false);
    }

    handleShow() {
        this.setShow(true);
    }

    setShow(show) {
        this.setState({show: show});
    }

    handleOnShow() {
        const {product} = this.state;
        let _this = this;

        $(".js-range-slider-set-weight").ionRangeSlider({
            min: 0,
            step: product.weight / 100,
            max: product.weight,
            from: 0,
            grid: true,
            onChange: function (data) {
                _this.setState({weight: data.from});
            },
        });
    }

    addBasket() {

        let data = new FormData();

        data.append('product_id', this.props.product_id);
        data.append('weight', this.state.weight);
        data.append('count', '1');


        RestRequest.post(config.restBasketVirtual, {
            body: data
        }).then(data => {
        });
    }

    render() {
        const {show, product, weight} = this.state;
        let price_rate = Math.round(product.price / product.weight), result = Math.round(price_rate * weight);

        return (
            <div>
                <div className="set-weight-buy" onClick={this.handleShow.bind(this)}>Купить на разновес</div>

                <Modal show={show} onHide={this.handleClose.bind(this)} onShow={this.handleOnShow.bind(this)}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div className="set-weight-modal">
                                <div className="set-weight-modal__title">{product.name}</div>
                                <div className="set-weight-modal__label">Купить на разновес</div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="set-weight-product">
                                    <img alt={product.name} className="set-weight-product-image" src={product.imageUrl}/>
                                </div>
                            </div>
                        </div>

                        <div className="set-weight-rate">
                            <div className="set-weight-rate-item value">{weight}{weight > 1 ? 'кг' : 'гр'}</div>

                            <div className="set-weight-rate-item">x</div>

                            <div className="set-weight-rate-item value">
                                <div className="set-weight-rate-item__value">{Price.format(price_rate)}{Currency.show()}</div>
                                <div className="set-weight-rate-item__label">за кг</div>
                            </div>
                            <div className="set-weight-rate-item">=</div>

                            <div className="set-weight-rate-item value">
                                <div className="set-weight-rate-item__value">{Price.format(result)}{Currency.show()}</div>
                                <div className="set-weight-rate-item__label">Итого</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <input type="text" className="js-range-slider-set-weight" name="my_range" value=""/>
                            </div>
                        </div>

                        <div className="row mt-5">
                            <div className="col-sm-6 col-12">
                                <BuyOneClick/>
                            </div>
                            <div className="col-sm-6 col-12">
                                <button onClick={this.addBasket.bind(this)} className="btn-main set-weight-basket">Добавить в корзину</button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }

}